import { render, staticRenderFns } from "./PlansQuestions.vue?vue&type=template&id=aeaca894&scoped=true"
import script from "./PlansQuestions.vue?vue&type=script&lang=js"
export * from "./PlansQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaca894",
  null
  
)

export default component.exports